<div class="grid-container">
    @if(gridConfigItems?.showSearch || gridConfigItems?.showFilter){
    <div class="grid-container__filter-search">
       
        <div class="grid-container__filter">
            <!-- Slot for controls that belong to the grid's own toolbar rather than above it —
                 e.g. a bulk-action picker that appears once rows are selected. Projected content
                 is evaluated in the parent's context, so its bindings and template refs stay
                 with the consumer. -->
            <ng-content></ng-content>
             @if(gridConfigItems?.showFilter){
            <div class="eod-input" [ngClass]="gridConfigItems?.searchBarClass" [class.d-none]="hideFilterAndSearch">
                <label for="country" class="form-label">{{filterLabel}}</label>
                <ng-select 
                    [items]="dropdownList" 
                    bindLabel="dropdownName" 
                    bindValue="dropdownName"
                    [(ngModel)]="selectedFilter"
                    (change)="handleFilterChange($event)"
                    (clear)="onClear()"
                    [clearable]="false"
                    [searchable]="true" 
                    class="select-dropdown select-dropdown--md" 
                    [notFoundText]="textNotFound" name="dropdown">
                </ng-select>
                <small class="helper-text"></small>
            </div>}
            @if(gridConfigItems?.showTagTextValue && tagTextValue){
            <div class="grid-header_tag">
                <p>{{tagTextValue}}</p>
            </div>}
        </div>
        @if(gridConfigItems?.showSearch){
        <div class="grid-container__search" [class.d-none]="hideFilterAndSearch">
            <ds-textbox #searchField [textboxInput]="searchTextboxConfig"
                (valueChange)="onGridSearchTextChange($event)">
            </ds-textbox>
        </div>}
    </div>
    }
    <section class="ag-theme-alpine">
        <ag-grid-angular #agGrid class="ag-theme-alpine" style="width: 100%; height: 100%;"
            (gridReady)="onGridReady($event)" (cellClicked)="onCellClicked($event)" [gridOptions]="gridOptions"
            [theme]="'themeAlpine'" [sideBar]="true" [headerHeight]="40" [columnHoverHighlight]="false"
            [pinnedBottomRowData]="pinnedBottomRowData" [rowClassRules]="gridConfigItems?.rowClassRules"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate" [overlayLoadingTemplate]="overlayLoadingTemplate">
        </ag-grid-angular>
    </section>
</div>